export { Rating } from '@mantine/core'